import { Quote } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const ExpertStatementClean = () => {
  const expert = {
    name: "Thomas Dewein",
    title: "Versicherungsexperte Cyberrisiken",
    experience: "15+ Jahre Erfahrung im Schutz medizinischer Einrichtungen",
    quote: "Die häufigsten Cyberangriffe auf Praxen könnten mit einfachen Maßnahmen verhindert werden. Diese Checkliste zeigt Ihnen genau, wie.",
    image: "/thomas-dewein-photo.jpg"
  };
  return <section className="py-20 sm:py-28 lg:py-32 relative">
      {/* Dezenter Gradient Overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, hsl(var(--accent) / 0.05), transparent 65%)"
    }} />
      
      <div className="container max-w-4xl mx-auto px-6 sm:px-8 relative z-10">
        
        <div className="border border-white/10 rounded-xl p-10 sm:p-12 backdrop-blur-sm relative">
          
          {/* Quote Icon */}
          <Quote className="absolute top-6 right-6 w-16 h-16 text-accent/10" />
          
          {/* Zentrierter Content */}
          <div className="text-center">
            
            {/* Avatar */}
            <div className="flex justify-center mb-6">
              <Avatar className="w-24 h-24 sm:w-28 sm:h-28 border-4 border-accent/30">
                <AvatarImage src={expert.image} alt={expert.name} />
                <AvatarFallback className="bg-accent/20 text-accent text-3xl font-bold">
                  TD
                </AvatarFallback>
              </Avatar>
            </div>
            
            {/* Quote */}
            <blockquote className="text-xl sm:text-2xl md:text-3xl italic text-foreground/90 mb-8 leading-relaxed max-w-3xl mx-auto py-[6px] my-[20px]">
              "{expert.quote}"
            </blockquote>
            
            {/* Credentials */}
            <div className="font-bold text-foreground text-xl sm:text-2xl mb-2">{expert.name}</div>
            <div className="text-base sm:text-lg text-muted-foreground mb-1 my-0">{expert.title}</div>
            <div className="text-sm sm:text-base text-muted-foreground">{expert.experience}</div>
          </div>
        </div>
      </div>
    </section>;
};
export default ExpertStatementClean;